<pp-advanced-filter-option-select
  data-testid="timeline-date-select"
  class="advancedFilter__option"
  [ppItems]="advancedFilterTimelineDates"
  [ppOption]="selectedDate"
  (ppOptionChange)="changeFieldDate($event)"
  ppClass="advancedFilter__option--condition"
></pp-advanced-filter-option-select>

<div class="advancedFilter__dateContainer">
  @if (
    filter.date === EAdvancedFilterTimelineDate.START_DATE ||
    filter.date === EAdvancedFilterTimelineDate.END_DATE
  ) {
    <pp-advanced-filter-option-select
      data-testid="timeline-condition-select"
      class="advancedFilter__option"
      [ppItems]="advancedFilterTimelineOptions"
      [ppOption]="option"
      (ppOptionChange)="changeFieldCondition($event)"
      ppClass="advancedFilter__option--minWidth"
    />
  }

  @if (
    filter.date !== EAdvancedFilterTimelineDate.IS_EMPTY &&
    filter.date !== EAdvancedFilterTimelineDate.IS_NOT_EMPTY
  ) {
    @if (
      option === EAdvancedFilterOptions.IS_BETWEEN ||
      option === EAdvancedFilterOptions.IS_BEFORE ||
      option === EAdvancedFilterOptions.IS_AFTER ||
      option === EAdvancedFilterOptions.IS ||
      option === EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL ||
      option === EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL
    ) {
      <pp-datepicker
        data-testid="timeline-field-value"
        [ppDate]="startDate"
        (ppSelect)="changeFieldValue($event, 0)"
        [ppPlaceholder]="
          (option === EAdvancedFilterOptions.IS_BETWEEN ? 'from...' : 'select_date') | ppTranslate
        "
      />
    }

    @if (option === EAdvancedFilterOptions.IS_BETWEEN) {
      <div>-</div>
    }

    @if (option === EAdvancedFilterOptions.IS_BETWEEN) {
      <pp-datepicker
        data-testid="timeline-field-value-end"
        [ppDate]="endDate"
        (ppSelect)="changeFieldValue($event, 1)"
        [ppPlaceholder]="'to...' | ppTranslate"
      ></pp-datepicker>
    }
  }
</div>
